import {Model} from 'vue-mc'
import {required, string, validation} from 'vue-mc/validation'

export default class Contact extends Model {
  defaults() {
    return {
      name: null,
      email: null,
      subject: null,
      message: null,
      interests: null,
    }
  }

  async sendEmail() {
    try {
      const params = this.attributes
      let request = await this.createRequest({
        method: "POST",
        url: `/api/v2/contacts`,
        data: {contact: params}
      }).send()

      if(request.response.data.status) {
        return request.response.data.status
      }
    } catch(error) {
      return null
    }
  }
}
